import * as React from 'react';

import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  useTheme,
} from '@mui/material';
import useReportSummary from 'hooks/useReportSummary';
import { useTranslation } from 'react-i18next';

import PositiveNegativeProductInformation from './PositiveNegativeProductInformation';
import useStyles from '../useStyles';

interface ReportProps {
  projectId: number;
  reportId: string;
}

const PositiveNegativeDrivers: React.FC<ReportProps> = (props) => {
  const { t } = useTranslation();
  const { projectId, reportId } = props;

  const classes = useStyles(useTheme());

  const {
    loading: reportSummaryLoading,
    error: reportSummaryError,
    data: reportSummaryData,
    topProduct,
    bottomProduct,
  } = useReportSummary(reportId);

  if (reportSummaryLoading) {
    return <Skeleton variant="rectangular" height={600} animation="wave" />;
  }

  if (reportSummaryError || topProduct === null || bottomProduct === null) {
    return <></>;
  }

  const drivers = t('reports.drivers');

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <CardHeader title={drivers} className={classes.header} />
        <PositiveNegativeProductInformation
          projectId={projectId}
          reportId={reportId}
          product={topProduct}
        />
        <PositiveNegativeProductInformation
          projectId={projectId}
          reportId={reportId}
          product={bottomProduct}
        />
      </CardContent>
    </Card>
  );
};

export default PositiveNegativeDrivers;
